module.exports = __webpack_public_path__ + "img/file_gray.1e0e1b4e.svg";